import { RouteController, Get, Post, RequestMethod, RouteGroup } from '../route-group';

// region Method Parameter Types

export interface RouteBaseOptions {}

export interface ListManagedCasePlanTemplatesOptions extends RouteBaseOptions {
  // ...
}

export interface ListCasePlanTemplateCommitsOptions extends RouteBaseOptions {
  templateId: string;
}

export interface GetCasePlanTemplateCommitOptions extends RouteBaseOptions {
  templateId: string;
  commitId: string;
}

export interface CreateCasePlanTemplateOptions extends RouteBaseOptions {
  // ...
}

export interface CommitManagedCasePlanTemplateOptions extends RouteBaseOptions {
  templateId: string;
}

export interface TagCasePlanTemplateCommitOptions extends RouteBaseOptions {
  templateId: string;
  commitId: string;
}

export interface SetCasePlanTemplateCommitStatusOptions extends RouteBaseOptions {
  templateId: string;
  commitId: string;
}

// endregion Method Parameter Types

@RouteController('mcpt')
export class ManagedCasePlanTemplatesRouteGroup extends RouteGroup {
  /** ... */
  @Get('managed-case-plan-templates')
  readonly listManagedCasePlanTemplates!: RequestMethod<any, ListManagedCasePlanTemplatesOptions>;

  /** ... */
  @Get('managed-case-plan-templates/:templateId/commits')
  readonly listCasePlanTemplateCommits!: RequestMethod<any, ListCasePlanTemplateCommitsOptions>;

  /** ... */
  @Get('managed-case-plan-templates/:templateId/commits/:commitId')
  readonly getCasePlanTemplateCommit!: RequestMethod<any, GetCasePlanTemplateCommitOptions>;

  /** ... */
  @Post('managed-case-plan-templates')
  readonly createCasePlanTemplate!: RequestMethod<any, CreateCasePlanTemplateOptions>;

  /** ... */
  @Post('managed-case-plan-templates/:templateId/commit')
  readonly commitManagedCasePlanTemplate!: RequestMethod<any, CommitManagedCasePlanTemplateOptions>;

  /** ... */
  @Post('managed-case-plan-template/:templateId/commits/:commitId/tag')
  readonly tagCasePlanTemplateCommit!: RequestMethod<any, TagCasePlanTemplateCommitOptions>;

  /** ... */
  @Post('managed-case-plan-template/:templateId/commits/:commitId/status')
  readonly setCasePlanTemplateCommitStatus!: RequestMethod<any, SetCasePlanTemplateCommitStatusOptions>;
}
